/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_DeleteInputs */



/**
* | output |
* | --- |
* | "Delete promo" |
*
* @param {Promo_DeleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_delete = /** @type {((inputs?: Promo_DeleteInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_DeleteInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer la promo")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar promo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Excluir promo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina promo")
	return /** @type {LocalizedString} */ ("Delete promo")
});